var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2261 14.2501C20.8161 14.2501 20.4761 14.5901 20.4761 15.0001V18.0001C20.4761 18.6901 19.9161 19.2501 19.2261 19.2501H5.22607C4.53607 19.2501 3.97607 18.6901 3.97607 18.0001V15.0001C3.97607 14.5901 3.63607 14.2501 3.22607 14.2501C2.81607 14.2501 2.47607 14.5901 2.47607 15.0001V18.0001C2.47607 19.5201 3.70607 20.7501 5.22607 20.7501H19.2261C20.7461 20.7501 21.9761 19.5201 21.9761 18.0001V15.0001C21.9761 14.5901 21.6361 14.2501 21.2261 14.2501Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7561 3.47C12.6061 3.32 12.4161 3.25 12.2261 3.25C12.0361 3.25 11.8461 3.32 11.6961 3.47L7.69608 7.47C7.40608 7.76 7.40608 8.24 7.69608 8.53C7.98608 8.82 8.46608 8.82 8.75608 8.53L11.4761 5.81L11.4761 16C11.4761 16.41 11.8161 16.75 12.2261 16.75C12.6361 16.75 12.9761 16.41 12.9761 16L12.9761 5.81L15.6961 8.53C15.9861 8.82 16.4661 8.82 16.7561 8.53C17.0461 8.24 17.0461 7.76 16.7561 7.47L12.7561 3.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.b9adc736778f285be53a90fea4010123.svg";
export { ForwardRef as ReactComponent };